// Red de seguridad para la pantalla del panel.
//
// En React, una excepción al pintar desmonta todo el árbol: el abogado queda
// mirando una pantalla EN BLANCO, sin mensaje, sin saber si perdió algo y sin
// nada que contarnos. Con esto el fallo queda acotado a la vista que reventó,
// el resto del panel sigue en pie y la persona tiene un botón para volver y
// otro para avisarnos con el error ya adjunto.
import React from 'react';

type Props = { children: React.ReactNode; onVolver?: () => void };
type State = { error: Error | null };

export default class LimiteError extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Queda en la consola del navegador para poder diagnosticarlo si el
    // usuario nos comparte una captura.
    console.error('[panel] la vista falló al pintar:', error, info.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    const detalle = `${error.name}: ${error.message}`;
    return (
      <div style={{ padding: 28, textAlign: 'center' }}>
        <div style={{ fontSize: 34, marginBottom: 10 }}>⚠️</div>
        <div style={{ fontSize: 16, color: 'var(--cream,#e8e0d0)', marginBottom: 8, fontWeight: 500 }}>
          No pudimos mostrar esta pantalla
        </div>
        <div style={{ fontSize: 13, color: 'var(--text-body,#8a9bb5)', lineHeight: 1.6, maxWidth: 460, margin: '0 auto 18px' }}>
          Es un problema nuestro al dibujar la página, no de tus datos: <strong>nada se perdió
          ni se modificó</strong>. Puedes volver y seguir trabajando con normalidad.
        </div>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button className="p-btn-primary" onClick={() => { this.setState({ error: null }); this.props.onVolver?.(); }}>
            ← Volver
          </button>
          <button className="p-btn-secondary" onClick={() => window.location.reload()}>Recargar</button>
        </div>
        <details style={{ marginTop: 16, fontSize: 11.5, color: 'var(--text-muted,#8a9bb5)' }}>
          <summary style={{ cursor: 'pointer' }}>Detalle técnico (útil si nos escribes)</summary>
          <code style={{ display: 'block', marginTop: 8, wordBreak: 'break-word' }}>{detalle}</code>
        </details>
      </div>
    );
  }
}
